module.exports = __webpack_public_path__ + "img/videoonline.fbf7723f.svg";